export const doctors = [
  { title: 'Dra. Ana Costa', value: 1, crm: '12345-SP' },
  { title: 'Dr. Bruno Gomes', value: 2, crm: '67890-RJ' },
  { title: 'Dra. Carla Dias', value: 3, crm: '11223-MG' }
]

export const formations = [
  { title: 'Clínica Médica', value: 'clinica_medica' },
  { title: 'Pediatria', value: 'pediatria' },
  { title: 'Ortopedia', value: 'ortopedia' }
]

export const teams = [
  { title: 'Equipe Interna', value: 'internal' },
  { title: 'Equipe Externa', value: 'external' }
]

export const allocators = [
  { title: 'Sistema Automático', value: 'system' },
  { title: 'Coordenador (João)', value: 'coord_joao' }
]

export const recurrence = [
  { title: 'Única', value: 'unique' },
  { title: 'Semanal', value: 'weekly' },
  { title: 'Quinzenal', value: 'fortnightly' },
  { title: 'Mensal ABCDE', value: 'abcde' }
]

export const repetition = [
  { title: 'Fim da escala', value: 'end_scale' },
  { title: 'Data personalizada', value: 'personalized' }
]

export const periodicity = [
  {
    value: 'COBERTURA',
    title: 'Cobertura',
    description: 'Médico está cobrindo a vaga'
  },
  {
    value: 'FIXO',
    title: 'Fixo',
    description: 'Irá alocar esse plantão de forma recorrente'
  }
]

export const weekOptions = [
  { value: 'A', label: 'A' },
  { value: 'B', label: 'B' },
  { value: 'C', label: 'C' },
  { value: 'D', label: 'D' },
  { value: 'E', label: 'E' }
]

export const dayOptions = [
  { value: 'dom', label: 'Dom.' },
  { value: 'seg', label: 'Seg.' },
  { value: 'ter', label: 'Ter.' },
  { value: 'qua', label: 'Qua.' },
  { value: 'qui', label: 'Qui.' },
  { value: 'sex', label: 'Sex.' },
  { value: 'sab', label: 'Sáb.' }
]

export const tableHeaders = [
  { key: 'id', label: 'ID' }, // { key: 'position', label: 'Posição' },
  { key: 'startDate', label: 'Data início' },
  { key: 'startTime', label: 'Horário início' },
  { key: 'endDate', label: 'Data fim' },
  { key: 'endTime', label: 'Horário fim' },
  { key: 'availability', label: 'Disponibilidade' },
  { key: 'value', label: 'Valor' }
]

export const mockShifts = [
  {
    id: '#48273', // position: 'CLINICO GERAL',
    startDate: '09/06/2025',
    startTime: '06:00',
    endDate: '10/06/2025',
    endTime: '07:00',
    availability: 'Aberta',
    value: 'R$500,00'
  },
  {
    id: '#19384', // position: 'CLINICO GERAL',
    startDate: '16/06/2025',
    startTime: '06:00',
    endDate: '17/06/2025',
    endTime: '07:00',
    availability: 'Com médico',
    value: 'R$500,00'
  },
  {
    id: '#75629', // position: 'CLINICO GERAL',
    startDate: '23/06/2025',
    startTime: '06:00',
    endDate: '24/06/2025',
    endTime: '07:00',
    availability: 'Aberta',
    value: 'R$500,00'
  }
]

export const recurrenceDescriptions = {
  unique: 'Irá alocar apenas este plantão.',
  weekly: 'Se repete a cada semana.',
  fortnightly: 'Se repete a cada duas semanas.',
  abcde:
    'Se repete semanalmente apenas em algumas semanas do mês. As semanas são ordenadas alfabeticamente, onde a primeira é a "A" e a última é a "E".'
}

export const removeRecurrenceOptions = [
  {
    title: 'Única',
    value: 'once',
    description: 'Se repete uma única vez'
  },
  {
    title: 'Semanal',
    value: 'weekly',
    description: 'Se repete a cada semana'
  },
  {
    title: 'Quinzenal',
    value: 'fortnightly',
    description: 'Se repete a cada duas semanas'
  },
  {
    title: 'Mensal ABCDE',
    value: 'abcde',
    description: 'Se repete semanalmente apenas em algumas semanas do mês'
  }
]

export const removeTableHeaders = [
  { key: 'id', label: 'ID' },
  { key: 'position', label: 'Posição' },
  { key: 'startDate', label: 'Data início' },
  { key: 'startTime', label: 'Horário início' },
  { key: 'endDate', label: 'Data fim' },
  { key: 'endTime', label: 'Horário fim' },
  { key: 'value', label: 'Valor' }
]

export const removePeriodicityOptions = [
  {
    value: 3,
    title: 'Escala',
    description: 'Remove o médico de todos os plantões desta escala.'
  },
  {
    value: 1,
    title: 'Pacote de vagas',
    description: 'Remove o vínculo do médico com este pacote específico de plantões.'
  },
  {
    value: 2,
    title: 'Posição + Turno',
    description: 'Remove o médico dos plantões com a mesma posição e turno do plantão selecionado.'
  }
]

export const dayMapping: { [key: string]: number } = {
  dom: 0,
  seg: 1,
  ter: 2,
  qua: 3,
  qui: 4,
  sex: 5,
  sab: 6
}

export const weekMapping: { [key: string]: number } = {
  A: 0,
  B: 1,
  C: 2,
  D: 3,
  E: 4
}
